import cisFertigationDataConfig from '@/api/config/cisFertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { IFormCisFertigation } from '@/types/cisFertigation'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function update(payload: IFormCisFertigation): Promise<void> {
  await cisFertigationDataConfig.edit(payload)
}

function useUpdateCisFertigation() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: IFormCisFertigation) => update(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.cisFertigation])
      toast.success(t('updateFertigationSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      if (error?.statusCode === 400) {
        toast.error(error?.message)
      } else toast.error(t('updateFertigationError'))
    },
  })
}

export default useUpdateCisFertigation
